export default __webpack_public_path__ + "static/media/mcl-logo-150.fa2b32df.jpg";